shadow$provide[133] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Node:{enumerable:true, get:function() {
  return Node;
}}});
var Pretty = require("../util/pretty.js");
var require$threestrap_SLASH_src_SLASH_binder_DOT_js = require("threestrap/src/binder.js");
let nodeIndex = 0;
class Node {
  constructor(type, defaults, options, binds, config, attributes) {
    this.type = type;
    this._id = (++nodeIndex).toString();
    this.configure(config, attributes);
    this.parent = this.root = this.path = this.index = null;
    this.set(defaults, true, true);
    this.set(options, false, true);
    this.bind(binds, false);
  }
  configure(config, attributes) {
    let {traits, props, finals, freeform} = config;
    if (traits == null) {
      traits = (this._config != null ? this._config.traits : undefined) != null ? this._config != null ? this._config.traits : undefined : [];
    }
    if (props == null) {
      props = (this._config != null ? this._config.props : undefined) != null ? this._config != null ? this._config.props : undefined : {};
    }
    if (finals == null) {
      finals = (this._config != null ? this._config.finals : undefined) != null ? this._config != null ? this._config.finals : undefined : {};
    }
    if (freeform == null) {
      freeform = (this._config != null ? this._config.freeform : undefined) != null ? this._config != null ? this._config.freeform : undefined : false;
    }
    this._config = {traits, props, finals, freeform};
    return this.attributes = attributes.apply(this, this._config);
  }
  dispose() {
    this.attributes.dispose();
    return this.attributes = null;
  }
  _added(parent) {
    this.parent = parent;
    this.root = parent.root;
    const event = {type:"add", node:this, parent:this.parent,};
    if (this.root) {
      this.root.trigger(event);
    }
    event.type = "added";
    return this.trigger(event);
  }
  _removed() {
    const event = {type:"remove", node:this,};
    if (this.root) {
      this.root.trigger(event);
    }
    event.type = "removed";
    this.trigger(event);
    return this.root = this.parent = null;
  }
  _index(index, parent) {
    let path;
    if (parent == null) {
      ({parent} = this);
    }
    this.index = index;
    this.path = path = index != null ? ((parent != null ? parent.path : undefined) != null ? parent != null ? parent.path : undefined : []).concat([index]) : null;
    this.order = path != null ? this._encode(path) : Infinity;
    if (this.root != null) {
      return this.trigger({type:"reindex"});
    }
  }
  _encode(path) {
    const k = 3;
    const map = x => k / (x + k);
    const lerp = t => b + (a - b) * t;
    let a = 1 + 1 / k;
    let b = 0;
    for (const index of Array.from(path)) {
      const f = map(index + 1);
      const g = map(index + 2);
      [a, b] = Array.from([lerp(f), lerp(g)]);
    }
    return a;
  }
  toString() {
    const _id = this.id != null ? this.id : this._id;
    const tag = this.type != null ? this.type : "node";
    let id = tag;
    id += `#${_id}`;
    if (this.classes != null ? this.classes.length : undefined) {
      id += `.${this.classes.join(".")}`;
    }
    if (this.children != null) {
      let count;
      if (count = this.children.length) {
        return `<${id}>\u2026(${count})\u2026</${tag}>`;
      } else {
        return `<${id}></${tag}>`;
      }
    } else {
      return `<${id} />`;
    }
  }
  toMarkup(selector = null, indent) {
    let k, v;
    if (indent == null) {
      indent = "";
    }
    if (selector && typeof selector !== "function") {
      let left;
      selector = (left = this.root != null ? this.root.model._matcher(selector) : undefined) != null ? left : () => true;
    }
    const tag = this.type != null ? this.type : "node";
    let {expr} = this;
    const orig = {id:this._id};
    const object = typeof this.orig === "function" ? this.orig() : undefined;
    for (k in object) {
      v = object[k];
      orig[k] = v;
    }
    const props = (() => {
      const result = [];
      for (k in orig) {
        v = orig[k];
        if (!this.expr[k]) {
          result.push(Pretty.JSX.prop(k, v));
        }
      }
      return result;
    })();
    expr = (() => {
      const result1 = [];
      for (k in expr) {
        v = expr[k];
        result1.push(Pretty.JSX.bind(k, v));
      }
      return result1;
    })();
    let attr = [""];
    if (props.length) {
      attr = attr.concat(props);
    }
    if (expr.length) {
      attr = attr.concat(expr);
    }
    attr = attr.join(" ");
    let child = indent;
    const recurse = () => {
      if (!(this.children != null ? this.children.length : undefined)) {
        return "";
      }
      return this.children.map(x => x.toMarkup(selector, child)).filter(x => x != null && x.length).join("\n");
    };
    if (selector && !selector(this)) {
      return recurse();
    }
    if (this.children != null) {
      const open = `<${tag}${attr}>`;
      const close = `</${tag}>`;
      child = indent + "  ";
      let children = recurse();
      if (children.length) {
        children = "\n" + children + "\n" + indent;
      }
      if (children == null) {
        children = "";
      }
      return indent + open + children + close;
    } else {
      return `${indent}<${tag}${attr} />`;
    }
  }
  print(selector, level) {
    return Pretty.print(this.toMarkup(selector), level);
  }
}
require$threestrap_SLASH_src_SLASH_binder_DOT_js.Binder.apply(Node.prototype);

};